"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.decompress = exports.compress = void 0;
var lz_string_1 = __importDefault(require("lz-string"));
var compress = function (o) {
    var compressed = lz_string_1.default.compress(JSON.stringify(o));
    return compressed;
};
exports.compress = compress;
var decompress = function (d) {
    var hexmapDecompressed = lz_string_1.default.decompress(d);
    return JSON.parse(hexmapDecompressed || '');
};
exports.decompress = decompress;
